import { render, staticRenderFns } from "./ProductDetail_Coupon.vue?vue&type=template&id=5cd6f4b0&scoped=true"
import script from "./ProductDetail_Coupon.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6f4b0",
  null
  
)

export default component.exports